import { useEffect } from 'react'
import useControlledTableProperty from '../Utils/useControlledTableProperty'

const useFilters = ({
    defaultFilters,
    onFilterChange,
    filtersVisible,
    onFiltersVisibleChange,
    table,
  }) => {

  const [columnFilters, setColumnFilters] = useControlledTableProperty({
    initialValue: [],
    controlledValue: defaultFilters,
    name: 'columnFilters',
    onChangeFn: onFilterChange
  })

  useEffect(() => {
    table?.setColumnFilters(defaultFilters || [])
  }, [defaultFilters])

  const [showFilters, setShowFilters] = useControlledTableProperty({
    initialValue: false,
    controlledValue: filtersVisible,
    name: 'showFilters',
    onChangeFn: onFiltersVisibleChange
  })

  useEffect(() => {
    setShowFilters(!!filtersVisible)
  }, [])

  return {
    columnFilters,
    setColumnFilters: setColumnFilters,
    showFilters,
    setShowFilters
  }
}

export default useFilters